import {PIXI} from '@colonist/pixi'
import {SectionBgView} from './SectionBgView'
import {UICanvasConfig} from './UICanvasConfig'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {GameColor} from '../GameColor'

interface Dimensions {
    width: number
    height: number
}

export class SectionBgAdaptiveView extends PIXI.Container {
    private sectionBgView: SectionBgView
    private textDimensions: Dimensions = {width: 0, height: 0}

    get absoluteHeight(): number {
        const absoluteHeight = this.getLocalBounds().top + this.height
        return absoluteHeight
    }

    get absoluteWidth(): number {
        const absoluteWidth = this.getLocalBounds().left + this.width
        return absoluteWidth
    }

    override addChild<U extends PIXI.DisplayObject[]>(...children: U): U[0] {
        for(const child of children) {
            if(child instanceof PIXI.Text) this.textDimensions = {width: this.textDimensions.width + child.width, height: this.textDimensions.height + child.height}
        }
        return super.addChild(...children)
    }

    drawTextureBgAroundContent(horizontalBuffer: number = 0, verticalBuffer: number = 0, backgroundTexture: PIXI.Texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_section), radius: number = 5) {
        this.resetSectionBgView(horizontalBuffer, verticalBuffer)

        this.sectionBgView.drawRoundedBg(backgroundTexture, undefined, radius)
        this.sectionBgView.zIndex = -1
        this.sortChildren()
    }

    drawBgAroundContent(horizontalBuffer: number = 0, verticalBuffer: number = 0, alpha: number = 1, radius: number = 5) {
        this.resetSectionBgView(horizontalBuffer, verticalBuffer)

        this.sectionBgView.drawBg(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6), alpha, 1, GameColor.getColorHexValue(GameColor.Color.White), 1, radius)
        this.sectionBgView.zIndex = -1
        this.sortChildren()
    }

    private resetSectionBgView(horizontalBuffer: number, verticalBuffer: number) {
        this.sectionBgView?.parent?.removeChild(this.sectionBgView)
        const fullWidth = this.calculateFullWidth(horizontalBuffer)
        const fullHeight = this.calculateFullHeight(verticalBuffer)

        this.sectionBgView = new SectionBgView(0, 0, fullWidth, fullHeight, this)
    }

    private calculateFullWidth(horizontalBuffer: number): number {
        const textWidth = this.textDimensions.width
        const spritesWidth = this.absoluteWidth + UICanvasConfig.margin + horizontalBuffer
        return textWidth > spritesWidth ? textWidth : spritesWidth
    }

    private calculateFullHeight(verticalBuffer: number): number {
        const textHeight = this.textDimensions.height
        const spritesHeight = this.absoluteHeight + UICanvasConfig.margin + verticalBuffer
        return textHeight > spritesHeight ? textHeight : spritesHeight
    }
}
